import { memo } from "react";

import classnames from "classnames";
import { capitalize } from "neetocist";
import { globalProps } from "neetocommons/initializers";
import { Neeto } from "neetoicons/typeface-logos";
import * as ProductTypefaceLogos from "neetoicons/typeface-logos";
import { Link } from "react-router-dom";

import { DEFAULT_HOME_PATH, SPECIAL_APP_NAMES } from "../constants";

const Header = ({ customLogo, clearSettingsNav }) => {
  const productName = globalProps.appName.substr(5);
  const normalizedName = (productName || "").trim().toLowerCase();
  const specialCase = SPECIAL_APP_NAMES[normalizedName];
  const logoName = specialCase
    ? `Neeto${specialCase}`
    : `Neeto${capitalize(normalizedName)}`;
  const ProductTypefaceLogo = ProductTypefaceLogos[logoName] ?? Neeto;
  const LogoComponent = customLogo ?? ProductTypefaceLogo;
  const isOnboarded = globalProps.user.isOnboarded !== false;

  return (
    <div
      className="neeto-molecules-sidebar__header neeto-molecules-sidebar__no-shrinkable"
      data-testid="sidebar-info"
    >
      <Link
        to={DEFAULT_HOME_PATH}
        className={classnames(
          "neeto-molecules-sidebar__logo neeto-ui-w-full",
          { "cursor-pointer": isOnboarded },
          { "pointer-events-none": !isOnboarded }
        )}
        onClick={clearSettingsNav}
      >
        {globalProps.sidebarTitle ? (
          <span className="neeto-molecules-sidebar__title">
            {globalProps.sidebarTitle}
          </span>
        ) : (
          <LogoComponent
            className={classnames({
              "neeto-molecules-sidebar__logo": !customLogo,
            })}
          />
        )}
      </Link>
    </div>
  );
};

export default memo(Header);
